// extracted by mini-css-extract-plugin
export default {"pageLayout":"Personal_pageLayout__1K1Mh"};